import parseVariableAttributes from "./parseVariableAttributes";

export default function parseVariable(xmlNode) {
  return {
    type: "variable",
    attrs: parseVariableAttributes(xmlNode.getAttribute("id")),
    text: xmlNode.textContent,
  };
}
